import { STEP_ID } from "@/components/constants";

/**
 * Estimated time, in minutes, that a new hire takes to complete each onboarding step.
 *
 * These are fixed approved estimates, not derived from telemetry. Deriving them from median
 * step completion data was considered and deliberately not pursued, so there is no pending
 * swap to a live source. Every consumer still reads them through
 * {@link getStepEstimatedMinutes}, so if that decision is ever revisited the source can
 * change without touching the components that display it.
 */
const STEP_ESTIMATED_MINUTES: Record<STEP_ID, number> = {
  [STEP_ID.IDENTITY_CHECK]: 10,
  [STEP_ID.AMAZON_USERNAME]: 1,
  [STEP_ID.INSERT_AND_TEST_SECURITY_KEY]: 2,
  [STEP_ID.REGISTER_SECURITY_KEY]: 5,
  [STEP_ID.CONNECT_VPN]: 5,
  [STEP_ID.AMAZON_PASSWORD]: 3,
  [STEP_ID.PRE_CACHE_AD_MOBILE]: 3,
  [STEP_ID.AMAZON_ACCOUNT_CACHING]: 1,
};

/**
 * Returns the estimated number of minutes to complete the given step.
 *
 * @param stepId The step to look up.
 */
export const getStepEstimatedMinutes = (stepId: STEP_ID): number =>
  STEP_ESTIMATED_MINUTES[stepId];
